module.exports = __webpack_public_path__ + "img/sport-m-1.f1b429fd.jpg";